import React, { useState } from 'react';
import { Pencil, CalendarClock, CheckCircle2, MoreHorizontal, RefreshCw, XCircle, Trash2 } from 'lucide-react';
import Button from '../ui/Button';
import StatusPicker from './StatusPicker';

export default function JobActions({ job, onEdit, onSchedule, onComplete, onCancel, onDelete, onStatusChange }) {
  const [showMenu, setShowMenu] = useState(false);
  const [showStatusPicker, setShowStatusPicker] = useState(false);

  const canComplete = job.status === 'scheduled';
  const canCancel = job.status !== 'cancelled' && job.status !== 'completed';
  const canSchedule = !job.scheduledDate;

  function handleStatusChange(newStatus) {
    onStatusChange(newStatus);
    setShowStatusPicker(false);
  }

  return (
    <>
      <div style={{ display: 'flex', gap: '8px', position: 'relative' }}>
        <Button size="small" onClick={onEdit}>
          <Pencil size={13} strokeWidth={2.25} /> Edit
        </Button>

        {canSchedule && (
          <Button size="small" onClick={onSchedule}>
            <CalendarClock size={13} strokeWidth={2.25} /> Schedule
          </Button>
        )}

        {canComplete && (
          <Button variant="secondary" size="small" onClick={onComplete}>
            <CheckCircle2 size={13} strokeWidth={2.25} /> Mark Complete
          </Button>
        )}

        {/* More Actions Dropdown */}
        <div style={{ position: 'relative' }}>
          <Button
            variant="secondary"
            size="small"
            onClick={() => setShowMenu(!showMenu)}
          >
            <MoreHorizontal size={13} strokeWidth={2.25} /> More
          </Button>

          {showMenu && (
            <>
              {/* Backdrop to close menu */}
              <div
                onClick={() => setShowMenu(false)}
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 999
                }}
              />

              {/* Menu */}
              <div style={{
                position: 'absolute',
                top: '100%',
                right: 0,
                marginTop: '8px',
                background: 'var(--bg-card)',
                borderRadius: '12px',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
                border: '1px solid rgba(0, 0, 0, 0.08)',
                minWidth: '180px',
                zIndex: 1000,
                overflow: 'hidden'
              }}>
                <button
                  onClick={() => {
                    setShowMenu(false);
                    setShowStatusPicker(true);
                  }}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: 'transparent',
                    border: 'none',
                    textAlign: 'left',
                    fontSize: '14px',
                    color: 'var(--text-primary)',
                    cursor: 'pointer',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = 'var(--action-menu-hover)'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                >
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                    <RefreshCw size={14} strokeWidth={2.25} /> Update Status
                  </span>
                </button>

                {canCancel && (
                  <>
                    <div style={{
                      height: '1px',
                      background: 'var(--action-menu-divider)',
                      margin: '4px 0'
                    }} />

                    <button
                      onClick={() => {
                        onCancel();
                        setShowMenu(false);
                      }}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        background: 'transparent',
                        border: 'none',
                        textAlign: 'left',
                        fontSize: '14px',
                        color: 'var(--text-primary)',
                        cursor: 'pointer',
                        transition: 'background 0.2s'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.background = 'var(--action-menu-hover)'}
                      onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                    >
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                        <XCircle size={14} strokeWidth={2.25} /> Cancel Job
                      </span>
                    </button>
                  </>
                )}

                <div style={{
                  height: '1px',
                  background: 'var(--action-menu-divider)',
                  margin: '4px 0'
                }} />

                <button
                  onClick={() => {
                    onDelete();
                    setShowMenu(false);
                  }}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: 'transparent',
                    border: 'none',
                    textAlign: 'left',
                    fontSize: '14px',
                    color: 'var(--status-text-bold-red)',
                    cursor: 'pointer',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = 'var(--action-menu-danger-hover)'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                >
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                    <Trash2 size={14} strokeWidth={2.25} /> Delete Job
                  </span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Status Picker Modal */}
      <StatusPicker
        isOpen={showStatusPicker}
        onClose={() => setShowStatusPicker(false)}
        currentStatus={job.status}
        onStatusChange={handleStatusChange}
      />
    </>
  );
}